import { useForm } from 'react-hook-form';
import { resolver } from './utils';

const defaultValues = {
  password: '',
  reasonDetails: '',
};

export const useCancelRequisitionForm = () => {
  const {
    watch,
    control,
    setValue,
    setError,
    handleSubmit,
  } = useForm({
    resolver,
    defaultValues,
  });

  const createOnSubmit = ({ cancelRequisition }) => handleSubmit((values) => cancelRequisition({
    variables: {
      input: {
        reason: values.reason,
        otherReason: values.reasonDetails,
      },
    },
    context: {
      password: values.password,
    },
  }));

  return {
    watch,
    control,
    setValue,
    setError,
    createOnSubmit,
  };
};
